import { render, staticRenderFns } from "./RiskAnalysis.vue?vue&type=template&id=795ae6e0&scoped=true&"
import script from "./RiskAnalysis.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./RiskAnalysis.vue?vue&type=style&index=0&id=795ae6e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ae6e0",
  null
  
)

export default component.exports